import { forwardRef, InputHTMLAttributes } from 'react';

import StatusSuccess from '@assets/svg/status-success.svg';
import StatusError from '@assets/svg/status-error.svg';

import { Container, TextInput, Icon } from './Input.styles';

interface IInput extends InputHTMLAttributes<HTMLInputElement> {
  status?: 'none' | 'success' | 'error';
}

const Input = forwardRef<HTMLInputElement, IInput>(
  ({ status, ...props }, ref) => {
    return (
      <Container>
        {(() => {
          if (status === 'success') {
            return <Icon src={StatusSuccess} alt="success" />;
          }

          if (status === 'error') {
            return <Icon src={StatusError} alt="error" />;
          }

          return null;
        })()}
        <TextInput
          ref={ref}
          status={status}
          hasIcon={status === 'success' || status === 'error'}
          {...props}
        />
      </Container>
    );
  },
);

export { Input };
